module.exports = __webpack_public_path__ + "img/item.109a269e.svg";